<template>
  <div class="container">
    <login-header :systemName="systemName" pageType="login" />
    <component :is="componentName"></component>
    <water-marker :textStyle="waterMarkerTextStyle" :text="waterMarkerText || setting.defaultWaterMarker" :key="waterMarkerKey"></water-marker>
    <login-footer :copyright="copyright" :ICP="setting.ICP" />
  </div>
</template>

<script>
import setting from '../../settings.js'
import WaterMarker from '@/components/waterMarker/WaterMarker'
import LoginHeader from './Header'
import LoginFooter from './Footer'
import Login from './Login'

export default {
  name: 'Common',
  components: {WaterMarker, LoginHeader, LoginFooter, Login},
  data () {
    return {
      componentName: 'Login',
      waterMarkerKey: 0,
      waterMarkerText: '',
      waterMarkerTextStyle: {
        rotate: 30
      },
      setting: setting
    }
  },
  beforeCreate () {
    let fontSize = 20 * document.body.clientWidth / 1920
    if (fontSize < 14.25) {
      document.getElementsByTagName('html')[0].style.fontSize = '14.25px'
    } else {
      document.getElementsByTagName('html')[0].style.fontSize = fontSize + 'px'
    }
  },
  mounted () {
    window.onresize = () => {
      this.$nextTick(() => {
        this.resetHtmlFontSize()
      })
    }
  },
  computed: {
    systemName () {
      return this.$store.state.setting.systemName
    },
    copyright () {
      return this.$store.state.setting.copyright
    }
  },
  methods: {
    resetHtmlFontSize () {
      let fontSize = 20 * document.body.clientWidth / 1920
      if (fontSize < 14.25) {
        document.getElementsByTagName('html')[0].style.fontSize = '14.25px'
      } else {
        document.getElementsByTagName('html')[0].style.fontSize = fontSize + 'px'
      }
    }
  }
}
</script>

<style lang="less" scoped>
  .container {
    display: flex;
    flex-direction: column;
    height: 100vh;
    overflow: auto;
    background-size: 100% 100%;
  }
</style>



// WEBPACK FOOTER //
// Common.vue?ab0ebbf4